import React from "react";

function LinesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_268_1659)">
        <path
          fill="#fff"
          d="M10 17a1 1 0 001 1h2a1 1 0 100-2h-2a1 1 0 00-1 1zM4 6a1 1 0 000 2h16a1 1 0 100-2H4zm2 6a1 1 0 001 1h10a1 1 0 100-2H7a1 1 0 00-1 1z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_268_1659">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default LinesIcon;
